import { createInertiaApp } from "@inertiajs/react";
import { createRoot } from "react-dom/client";
import "../styles/application.css";

createInertiaApp({
  id: "app",
  resolve: (name) => {
    const pages = import.meta.glob("../pages/**/*.tsx", { eager: true });
    const page = pages[`../pages/${name}.tsx`] as any;
    return page?.default ?? page;
  },
  setup({ el, App, props }) {
    createRoot(el!).render(<App {...props} />);
  },
});
